import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { closeTaskTagsModal, taskTagsModalSelector } from 'store/modals'
import { newTagsSelector, resetNewTaskTag } from 'store/taskTags'
import ConfirmModal from 'ui/components/ConfirmModal'
import ModalBasic from 'ui/components/ModalBasic'
import TaskTagForm from 'ui/components/ModalTaskTags/TaskTagForm'
import TaskTagNew from 'ui/components/ModalTaskTags/TaskTagNew'
import { TAG_NAME_MAX_LENGTH } from 'utils/constants/taskTags'
import { Subtitle, FormHeader, HeaderCell } from './styled'

const ModalTaskTags = () => {
  const dispatch = useDispatch()
  const [confirmOpened, setConfirmOpened] = useState(false)
  const { open, title } = useSelector(taskTagsModalSelector)
  const newTags = useSelector(newTagsSelector)

  const handlerClose = () => {
    dispatch(closeTaskTagsModal())
    dispatch(resetNewTaskTag())
    setConfirmOpened(false)
  }

  return (
    <ModalBasic
      size={'wide'}
      open={open}
      handlerClose={() => setConfirmOpened(true)}
      title={title}
      onRouteChangeClose={() => {
        dispatch(closeTaskTagsModal())
        dispatch(resetNewTaskTag())
      }}
    >
      <Subtitle>
        Имя тега может быть не больше {TAG_NAME_MAX_LENGTH} символов с учётом
        пробелов.
      </Subtitle>
      <FormHeader>
        <HeaderCell>Название</HeaderCell>
        <HeaderCell>Описание</HeaderCell>
        <HeaderCell>Цвет</HeaderCell>
        <HeaderCell />
      </FormHeader>
      {newTags.length > 0 &&
        newTags.map((tag, i) => <TaskTagNew tag={tag} key={i} />)}
      <TaskTagForm setConfirmOpened={setConfirmOpened} />
      <div>
        <ConfirmModal
          title="Закрыть окно?"
          open={confirmOpened}
          confirmHandler={handlerClose}
          handlerClose={() => setConfirmOpened(false)}
        />
      </div>
    </ModalBasic>
  )
}

export default ModalTaskTags
